import React, { FC } from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

const AnimatedLoader: FC = () => {
  return (
    <DotLottieReact
      src="/animations/animation-1746349517889.lottie"
      loop
      autoplay
      style={{ width: 300 }}
    />
  );
};

export default AnimatedLoader;
